import {
  BlockTool,
  BlockToolConstructorOptions,
  BlockToolData,
  API,
} from '@editorjs/editorjs'
import './ProductCard.scss'

/**
 * Тип описывает данные, которые хранит наш плагин.
 */

interface ProductCardData extends BlockToolData {
  xid: string;
}

/**
 * Интерфейс для конфигурации плагина (если нужно что-то передавать извне).
 */

interface ProductCardConfig {
  placeholder?: string;
}

/**
 * Плагин (инструмент) для Editor.js, позволяющий вводить артикул товара.
 */

export default class ProductCard implements BlockTool {
  private api: API;
  private config: ProductCardConfig;
  private data: ProductCardData;
  private wrapper: HTMLElement | null;

  /**
   * Конструктор инструмента Editor.js
   * @param options Параметры, которые Editor.js передаёт в инструмент
   */

  constructor ({ data, config, api }: BlockToolConstructorOptions<ProductCardData, ProductCardConfig>) {
    this.api = api
    this.config = config || {}
    this.data = {
      xid: data.xid || '',
    }
    this.wrapper = null
  }

  /**
   * Свойство, по которому Editor.js показывает инструмент в "панели инструментов" (Toolbox).
   */

  public static get toolbox () {
    return {
      title: 'Карточка товара',

      /**
       * Ниже иконка в формате SVG. Можно заменить на любую другую.
       */

      icon: `<svg width="20" height="20" viewBox="0 0 20 20"
       xmlns="http://www.w3.org/2000/svg">
       <path d="M15.18 2.33H4.82C3.27 2.33 2 3.6 2 5.15v9.7c0 1.55 1.27 2.82 2.82 2.82h10.36c1.55 0 2.82-1.27 2.82-2.82V5.15c0-1.55-1.27-2.82-2.82-2.82zm-1.56 9.86-1.47 1.52c-.14.15-.33.23-.53.24-.2.01-.4-.07-.55-.22L9.4 11.2 6.93 13.71c-.15.15-.35.23-.55.22-.2-.01-.39-.09-.53-.24l-1.49-1.52a.757.757 0 0 1 0-1.07c.29-.29.76-.29 1.06 0l.96.98 1.97-2c.29-.3.76-.3 1.06 0l1.97 2 .95-.98c.29-.29.76-.29 1.06 0 .29.29.29.77 0 1.06z"/>
       </svg>`,
    }
  }

  /**
   * Метод, создающий DOM-элемент для отображения внутри редактора.
   */

  public render (): HTMLElement {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('editor-xid-tool')

    const label = document.createElement('label')
    label.textContent = 'Введите артикул товара: '

    const input = document.createElement('input')
    input.type = 'text'
    input.placeholder = this.config.placeholder || 'Введите артикул товара...'
    input.value = this.data.xid

    input.addEventListener('input', (event: Event) => {
      const target = event.target as HTMLInputElement
      this.data.xid = target.value
    })

    this.wrapper.appendChild(label)
    this.wrapper.appendChild(input)
    return this.wrapper
  }

  /**
   * Метод, который вызывается при сохранении данных из редактора.
   */

  public save (): ProductCardData {
    return {
      xid: this.data.xid,
    }
  }

  /**
   * Опционально: метод validate(), onPaste() и т.д. можно добавить при необходимости.
   */

}
